import CityPageTemplate from "../city-template/CityPageTemplate";
import { sedonaConfig } from "./data";

export default function SedonaPage() {
  return <CityPageTemplate config={sedonaConfig} />;
}